<template>
  <section class="wealth-rule">
    <img src="../assets/images/wealth-rule.png">
  </section>
</template>

<script>
export default {
  name: 'WealthRule'
}
</script>

<style lang="scss">
  @charset 'utf-8';
  @import '../style/main';

  $global-width: 750;

  .wealth-rule {
    padding: rem(40) rem(30);

    & > img {
      display: block;
      width: 100%;
    }
  }

  $global-width: 720;
</style>
